// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  direction: rtl;
  top: 0;
  left: 0;
  width: 250px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: sticky;
  background-image: linear-gradient(
    210.35deg,
    rgb(220, 57, 252) 17.35%,
    rgb(99, 69, 237) 78.23%
  );
}
.sidebar-logo-container {
  display: "flex";
  align-items: center;
}
.sidebar-logo-container img {
  width: 50%;
  padding: 2em;
}
.sidebar-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.sidebar-items {
  height: 100%;
  width: 100%;
}
.sidebar-item {
  padding: 1.5em;
  padding-left: 2em;
  display: flex;
  color: #ffffff;
  list-style: none;
  text-decoration: none;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}
.sidebar-item:hover {
  background-color: #5a3fd26b;
}
.sidebar-item-active {
  padding: 1.5em;
  padding-left: 2em;
  display: flex;
  color: #ffffff;
  list-style: none;
  text-decoration: none;
  align-items: center;
  justify-content: flex-start;
  background-color: #5a3fd26b;
  cursor: pointer;
}
.sidebar-item-icon {
  width: 20px;
  color: #ffffff;
}
.sidebar-item-label {
  font-size: small;
  font-weight: 600;
  margin-right: 15px;
}
/* Footer */
.sidebar-footer {
  padding: 1.5em;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB;;;;GAIC;AACH;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,WAAW;AACX;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB","sourcesContent":[".sidebar {\n  direction: rtl;\n  top: 0;\n  left: 0;\n  width: 250px;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  position: sticky;\n  background-image: linear-gradient(\n    210.35deg,\n    rgb(220, 57, 252) 17.35%,\n    rgb(99, 69, 237) 78.23%\n  );\n}\n.sidebar-logo-container {\n  display: \"flex\";\n  align-items: center;\n}\n.sidebar-logo-container img {\n  width: 50%;\n  padding: 2em;\n}\n.sidebar-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.sidebar-items {\n  height: 100%;\n  width: 100%;\n}\n.sidebar-item {\n  padding: 1.5em;\n  padding-left: 2em;\n  display: flex;\n  color: #ffffff;\n  list-style: none;\n  text-decoration: none;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n}\n.sidebar-item:hover {\n  background-color: #5a3fd26b;\n}\n.sidebar-item-active {\n  padding: 1.5em;\n  padding-left: 2em;\n  display: flex;\n  color: #ffffff;\n  list-style: none;\n  text-decoration: none;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #5a3fd26b;\n  cursor: pointer;\n}\n.sidebar-item-icon {\n  width: 20px;\n  color: #ffffff;\n}\n.sidebar-item-label {\n  font-size: small;\n  font-weight: 600;\n  margin-right: 15px;\n}\n/* Footer */\n.sidebar-footer {\n  padding: 1.5em;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
